import { Quote } from "lucide-react";
import { Chapter, Reveal } from "@/components/motion";
import { TESTIMONIALS } from "@/data/site";

export default function Testimonials() {
  return (
    <section className="bg-surface py-28 lg:py-36" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-6">
        <Chapter index="08" label="Client Feedback" />
        <Reveal delay={0.1}>
          <h2 className="mt-8 font-heading text-4xl font-extrabold leading-[1.08] tracking-tight text-navy sm:text-5xl">
            Trusted by <span className="text-gold">Construction Businesses</span>
          </h2>
          <p className="mt-4 text-xs italic text-charcoal/50">
            Sample testimonials shown for illustration — client references and company logos available on request.
          </p>
        </Reveal>

        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={i} delay={i * 0.08} className="h-full">
              <figure
                className="flex h-full flex-col border border-navy/10 bg-white p-8 transition-all duration-300 hover:-translate-y-1 hover:border-navy"
                data-testid={`testimonial-card-${i}`}
              >
                <Quote className="h-8 w-8 text-gold" />
                <blockquote className="mt-6 flex-1 text-[15px] leading-relaxed text-charcoal/80">
                  "{t.quote}"
                </blockquote>
                <figcaption className="mt-8 border-t border-navy/10 pt-5">
                  <p className="font-heading text-sm font-bold text-navy">{t.name}</p>
                  <p className="mt-1 text-xs text-charcoal/55">{t.company}</p>
                  <p className="mt-2 inline-block bg-surface px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-charcoal/40">
                    Sample
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
